module.exports = __webpack_public_path__ + "static/media/productos.5e946113.svg";